import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import moment from 'moment';
import useStyles from '../styles';
import { formatISO } from 'date-fns';
import { useStore } from 'src/stores';
import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Button, Skeleton } from '@mui/material';
import { DatePicker, toast } from '@livable/saas-react-components';
export const DateInlineCell = observer(_ref => {
  var _store$residencies$ba, _store$residencies$ba2;
  let row = _ref.row,
    fieldId = _ref.fieldId;
  const store = useStore();
  const classes = useStyles();
  const _useState = useState((row === null || row === void 0 ? void 0 : row[fieldId]) || null),
    _useState2 = _slicedToArray(_useState, 2),
    chosenDate = _useState2[0],
    setChosenDate = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showButton = _useState4[0],
    setShowButton = _useState4[1];
  const handleClick = async () => {
    const resp = await store.residencies.batchUpdateBillingSettingsAsync.run({
      list: [{
        residencyId: row.residencyId,
        billingStartDate: {
          value: chosenDate ? formatISO(chosenDate).split('T')[0] : null
        }
      }]
    }, [row.residencyId]);
    if (resp && resp.isSuccessful) {
      setShowButton(false);
      toast('success', {
        body: ['Successfully saved']
      });
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, ((_store$residencies$ba = store.residencies.batchUpdateBillingSettingsAsync) === null || _store$residencies$ba === void 0 || (_store$residencies$ba = _store$residencies$ba.inProgressUnicIds) === null || _store$residencies$ba === void 0 ? void 0 : _store$residencies$ba.includes(row.residencyId)) && /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    width: 124,
    height: 36
  }), !((_store$residencies$ba2 = store.residencies.batchUpdateBillingSettingsAsync) !== null && _store$residencies$ba2 !== void 0 && (_store$residencies$ba2 = _store$residencies$ba2.inProgressUnicIds) !== null && _store$residencies$ba2 !== void 0 && _store$residencies$ba2.includes(row.residencyId)) && /*#__PURE__*/React.createElement("div", {
    className: classes.dateInlineCell
  }, /*#__PURE__*/React.createElement(DatePicker, {
    label: chosenDate ? null : 'N/A',
    format: "MM/dd/yy",
    onChange: date => {
      var _store$homeDashboardS;
      setChosenDate(date);
      setShowButton(false);
      if (!moment(row === null || row === void 0 ? void 0 : row[fieldId]).isSame(moment(date))) setShowButton(true);
      if (!((_store$homeDashboardS = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS !== void 0 && _store$homeDashboardS.companyFeatureSet.isAppfolio) && !date) setShowButton(false);
    },
    value: chosenDate ? moment(chosenDate).toDate() : null
  }), showButton && /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    size: "small",
    className: classes.dateInlineCellSave,
    onClick: handleClick
  }, "Save")));
});